module.exports = __webpack_public_path__ + "img/dreamweavers-10.b9a71bc5.webp";